// The COMPACT opportunity card (ART-328, design 4f/4g) — what every opportunity and show invite looks like in an
// Opportunities list now: a type tag and the date, the title, one meta line (your role · your pay · reply by, or
// "You're in" / "You're out" once answered), and ONE button. Nothing is answered from the card any more — Details
// opens the full view (a pop-up on desktop, a bottom sheet on the phone), where the answer lives.
//
// Presentational: the caller says what the row is and what its button does, so the band dashboard, the phone home
// and the roster all draw the same card.
import styles from "./OppCompactRow.module.scss";

export interface OppCompactRowProps {
  tag: string;
  /** "Dec 5" — or nothing for an undated row. */
  date?: string | null;
  title: string;
  /** The grey part after the title ("· Nashville"). */
  place?: string | null;
  /** The mono meta line: role · pay · reply-by, or the viewer's answer. */
  meta?: string | null;
  /** Part of the meta that turns red (a reply-by at three days or fewer). */
  urgent?: boolean;
  /** The button: "Details" for an invite, "Edit" for the creator. */
  actionLabel: string;
  onAction: () => void;
  /** A show request still waiting on the team (blue tag); a show invite (default tag). */
  tone?: "request" | "default";
}

export function OppCompactRow({ tag, date, title, place, meta, urgent, actionLabel, onAction, tone }: OppCompactRowProps) {
  return (
    <li className={styles.row}>
      <div className={styles.text}>
        <span className={styles.top}>
          <span className={styles.tag} data-tone={tone}>{tag}</span>
          {date && <span className={styles.date}>{date}</span>}
        </span>
        <span className={styles.title}>
          {title}
          {place && <span className={styles.place}> · {place}</span>}
        </span>
        {meta && <span className={styles.meta} data-urgent={urgent || undefined}>{meta}</span>}
      </div>
      <button
        type="button"
        className={styles.action}
        data-variant={actionLabel === "Details" ? "ink" : "ghost"}
        aria-label={`${actionLabel} — ${title}`}
        onClick={onAction}
      >
        {actionLabel}
      </button>
    </li>
  );
}
